import React from 'react'
import style from '../scss/components/BlueCTASection.module.scss'
import Button from './Button'
import { Fade } from "react-awesome-reveal"
import alarmImg from '../assets/alarm-animated.png'
import {RootStateOrAny, useSelector} from "react-redux"

const BlueCTASection = () => {
    const userIsLoggedIn: boolean = useSelector((state: RootStateOrAny) => state.auth.user_is_logged_in)
    const userLoggedInLink = process.env.REACT_APP_CHECKOUT_LINK_LOGGED_IN as string
    const questLink = process.env.REACT_APP_CHECKOUT_LINK_NOT_LOGGED_IN as string

    const renderButtons = () => {
        if (userIsLoggedIn) {
            return (
                <Button huge onClick={() => window.location.href = userLoggedInLink}>
                    Osta SalonLife’i kasutajana 75€
                </Button>
            )
        } else {
            return (
                <div className={style.Buttons}>
                    <Button huge inverted onClick={() => window.location.href = questLink}>
                        Osta külalisena 75€
                    </Button>
                    <Button huge onClick={() => window.location.href = userLoggedInLink}>
                        Osta SalonLife’i kasutajana 75€
                    </Button>
                </div>
            )
        }
    }

    return (
        <div className={style.Background} id={'offer'}>
            <Fade direction={'up'} triggerOnce={true}>
                <div className={style.Container}>
                    <div className={style.Flex}>
                        <div className={style.CenterContainer}>
                            <img src={alarmImg} width={150} height={150} alt={''}/>
                            <h2>
                                Osale SalonSecretsi veebikursusel<br/>
                                <strong>300€ soodsamalt!</strong>
                            </h2>
                            <div className={style.CheckList}>
                                <div className={style.CheckRow}>
                                    <div className={style.CheckIcon} />
                                    <div className={style.CheckRowTitle}>
                                        <span>4-osaline veebikursus</span> (~ 5h jagu videomaterjali)
                                    </div>
                                </div>
                                <div className={style.CheckRow}>
                                    <div className={style.CheckIcon} />
                                    <div className={style.CheckRowTitle}>
                                        <span>SalonSecrets e-raamat</span> | 60+ taktikat
                                    </div>
                                </div>
                                <div className={style.CheckRow}>
                                    <div className={style.CheckIcon} />
                                    <div className={style.CheckRowTitle}>
                                        <span>SalonSecrets e-töövihik</span>
                                    </div>
                                </div>
                                <div className={style.CheckRow}>
                                    <div className={style.CheckIcon} />
                                    <div className={style.CheckRowTitle}>
                                        <span>Järelvaadatav</span>
                                    </div>
                                </div>
                                <div className={style.CheckRow}>
                                    <div className={style.CheckIcon} />
                                    <div className={style.CheckRowTitle}>
                                        <span>25€</span> SalonLife’i krediiti
                                    </div>
                                </div>
                                <div className={style.CheckRow}>
                                    <div className={style.CheckIcon} />
                                    <div className={style.CheckRowTitle}>
                                        <span>100/100 garantii</span>
                                    </div>
                                </div>
                            </div>
                            <div className={style.DiscountApplied}>
                                <div className={style.DiscountAppliedTitle}>
                                    Lühiajaline soodustus: <span>-300€</span>
                                </div>
                            </div>
                            <s>Tavahind 375€</s>
                            <div className={style.DiscountedPrice}>
                                Soodushind: <strong>75€</strong>
                            </div>
                        </div>
                        <div className={style.Buttons}>
                            {renderButtons()}
                        </div>
                    </div>
                </div>
            </Fade>
        </div>
    )
}

export default BlueCTASection
